export const LATITUDE_PLACEHOLDER = 0
export const LONGITUDE_PLACEHOLDER = 0

export enum UserPermissionTypes {
  USE_SHOP = 'useShop',
}
